import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Link } from 'react-router-dom';

// import './loans.css';


const NoteInGrid = ( { note } ) => {
    const [ show, setShow ] = useState( false );
    const [ hasNote, setHasNote ] = useState( false );
    const [ title, setTitle ] = useState( '' );
    const [ details, setDetails ] = useState( '' );

    const handleOnMouseEnter = () => {
        setShow( true );
    }
    const handleOnMouseLeave = () => {
        setShow( false );
    }

    const ref = useRef();

    const popup = (
        <Popover id="popover-basic" className='tf-multi-lead-badge-container' onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <Popover.Header as="h3">{title}</Popover.Header>
            <Popover.Body style={ { maxHeight: '250px', overflowY: 'auto' } }>
                <div dangerouslySetInnerHTML={ { __html: details } }></div>
            </Popover.Body>
        </Popover>
    );

    useEffect( () => {
        if ( note ) {
            setTitle( note.name );
            setDetails( note.details );
            setHasNote( true );
        }
    }, [ note ] );

    return (
        <Container>
            <Row className='p-0'>
                {
                    hasNote ? (
                        <OverlayTrigger placement="left" overlay={popup} show={show} container={document.body}>
                            <Col xs='auto' className='ps-1 pe-1 align-items-center' style={ { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } } ref={ref} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>{title}</Col>
                        </OverlayTrigger>
                    ) : (
                        null
                    )
                }
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    notes: state.notes.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.loans.loadActives
} );
  
export default connect( mapProps, mapDispatch )( NoteInGrid );